var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid overflow-hidden bg-tile rounded p-10",style:(_vm.tilePosition)},[_c('div',{staticClass:"overflow-hidden p-padding align-self-center",class:{ 'filter-fade-tile': !_vm.noFade }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }